import React, { useState } from "react";
import axios from "axios";
import { IconButton, FormGroup, TextField, Grid } from "@mui/material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { theme } from "../../theme";
import {
  URI,
  HZ_AUTH_COOKIE_KEY,
  RETURN_URL_QUERY_KEY,
  LOGIN_PATH
} from "../../constants";

export function NoMSALAccessTokenValidator() {
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [scopes, setScopes] = useState([]);

  const [incorrectLogin, setIncorrectLogin] = useState(false);

  const usernameOnChange = (e) => {
    setIncorrectLogin(false);

    if (e.target?.value === undefined) {
      return;
    }

    setUsername(e.target.value);
    setDisableSubmit(password?.length === 0 || e.target.value.length === 0);
  };

  const passwordOnChange = (e) => {
    setIncorrectLogin(false);

    if (e.target?.value === undefined) {
      return;
    }

    setPassword(e.target.value);
    setDisableSubmit(username?.length === 0 || e.target.value.length === 0);
  };

  const handleEnterPressed = (e) => {
    setIncorrectLogin(false);

    if (e.key === "Enter" && !disableSubmit) {
      handleValidateKey();
    }
  };

  const handleValidateKey = async () => {
    setIncorrectLogin(false);

    const response = await axios
      .get(`${URI}/simplesignin?auth_code=${password}`)
      .then((res) => res)
      .catch((error) => error);

    if (response.status !== 200) {
      setIncorrectLogin(true);
      return;
    }

    window.location.href = "/customers"; 
  };

  return (
    <>
      <Grid
        container
        width={"fit-content"}
        direction="column"
        alignItems="center"
      >
        
        <TextField
            size="small"
            placeholder="Username"
            InputProps={{
              style: {
                textTransform: "uppercase",
                border: incorrectLogin ? "1px solid red" : "1px solid secondary.main",
                minWidth: "22ch"
              }
            }}
            onChange={usernameOnChange}
            onKeyDownCapture={handleEnterPressed}
            theme={theme}
          />
          <FormGroup>
          <TextField
            size="small"
            placeholder="Password"
            type="password"
            InputProps={{
              style: {
                textTransform: "uppercase",
                border: incorrectLogin ? "1px solid red" : "1px solid secondary.main",
                borderRight: "none",
                minWidth: "20ch",
                marginTop: "0.5rem"
              }
            }}
            onChange={passwordOnChange}
            onKeyDownCapture={handleEnterPressed}
            theme={theme}
          />
          <IconButton
            style={{
              borderRadius: 6,
              border: "1px solid secondary.main",
              borderLeft: "none",
              background: "#bbb",
              fontSize: "1rem",
              marginTop: "0.5rem"
            }}
            type="submit"
            variant="contained"
            theme={theme}
            disabled={disableSubmit}
            onClick={async () => await handleValidateKey()}
          >
            Sign In
          </IconButton>
        </FormGroup>
      </Grid>
      {incorrectLogin ? <div style={{color: "red"}}>Incorrect username or password.</div> : ""}
    </>
  );
}
